import {TextButton} from '../../index'

const RejectButton = ({className, onClick}) => {
    return (
        <TextButton className={className} clickHandler={onClick} variant={'text'}>Reject</TextButton>
    )
}

export default RejectButton